import { Button, Grid } from '@mui/material';
import moment, { Moment } from 'moment';
import React from 'react'
import dateStyles from './../../../assets/styles/componentStyles/datePickerStyles/datePickerStyles.module.scss'; 
import GlobalButton from '../../utility/globalButton/button';

interface DatePresetsProps {
    startDate: Moment | null;
    endDate: Moment | null;
    dateFormat: string;
    handlePresets: (start: Moment, end: Moment) => void;
    flagCloseBtn?: boolean;   
    flagApplytBtn?: boolean; 
    handleApplytBtnClick?: () => void,
    handleCloseBtn?: () => void,
}

const DatePresets = (props: DatePresetsProps) => {
    const {startDate, endDate, dateFormat, handlePresets, flagCloseBtn, flagApplytBtn, handleApplytBtnClick, handleCloseBtn} = props;
    const today = moment();
    const presets = [
        {
            text: "Last Week",
            start: moment().subtract(1, "week"),
            end: today
        },
        {
            text: "Last Month",
            start: moment().subtract(1, "month"),
            end: today
        },
        {
            text: "Last 3 Months",
            start: moment().subtract(3, "month"),
            end: today
        },
    ]
    return (
        <Grid item className={dateStyles.presetsButtonItem} > 
        <Grid container className={dateStyles.presetsButtonContainer}> 
            <Grid item> 
                <Grid container className={dateStyles.presetsButtonGap} >
                    {presets.map(({ text, start, end }, ind) => {
                        const isChosen =
                            startDate &&
                            endDate &&
                            moment(start).format(dateFormat) === moment(startDate).format(dateFormat) &&
                            moment(end).format(dateFormat) === moment(endDate).format(dateFormat);

                        return ( 
                            <Grid item>
                                <GlobalButton 
                                    buttonText={text}
                                    className={`${isChosen ? 'primaryButtonStyle' : 'borderedButtonStyle'}`}
                                    onClick={() => handlePresets(start, end)}
                                    sx={{ padding: '4px 10px !important' }}
                                />
                            </Grid>
                        );
                    })} 
                </Grid>
            </Grid>
            {flagCloseBtn &&  
                <Grid item className={dateStyles.closeBtnMargin} mt={{xs: "12px", lg: "0px"}}>
                    <GlobalButton 
                        buttonText='Close'
                        className={'primaryButtonStyle'}
                        sx={{ padding: '4px 16px !important' }}
                        onClick={() => {
                            if(handleCloseBtn){
                                handleCloseBtn();
                            }
                        }}
                    />
                </Grid>
            }
            {flagApplytBtn && 
                <Grid item className={dateStyles.closeBtnMargin}>
                <GlobalButton 
                    buttonText='Apply'
                    className={'primaryButtonStyle'}
                    sx={{ padding: '4px 16px !important' }}
                    onClick={() => {
                        if(handleApplytBtnClick){
                            handleApplytBtnClick();
                        }
                    }}
                />
            </Grid>
            }
        </Grid>
        </Grid>
    )
}

export default DatePresets
